<script>
  import chroma from 'chroma-js'
  export let day
  export let label
  export let id
  export let scale = chroma.scale(['#3B3B3B', 'hotpink']).domain([0, 100])

  function scaleTweet(val) {
    return scale(val)
  }
</script>

<div class="tweet-bar">
  <div class="tweet-wrap">
    <div class="tweets-label">{label}</div>
    <div class="tweet-row">
      {#each day as d1, i}
        <div
          id="{id}-{i}"
          class="tweets"
          style="background: {scaleTweet(+d1)};"
        />
      {/each}
    </div>
  </div>
</div>

<style>
  .tweet-bar {
    width: 100%;
    background: rgb(26, 26, 26);
  }
</style>
